<template lang="pug">
  .simple.user-form
    slot(name="header")
    component.user-container(:is="tag")
      h3.text-center.mb-6.text-2xl(v-if="! isAuthenticated") Anmelden
      Authenticate(:registration="false")
        .form-grid
          .sidebar
            ul
              li
                router-link(to="bestellungen" :disabled="true") Bestellungen
              li
                router-link(to="ruecksendungen" :disabled="true") Rücksendungen
              li
                router-link(to="account") Account
              li
                router-link(to="adressen") Adressen
          main.form
            router-view(:key="$route.path")
    slot(name="footer")
</template>

<script>
import { mapGetters } from 'vuex';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';

export default {
    name: 'UserForm',
    components: {
        Authenticate
    },
    computed: {
        tag() {
            let tag = 'main';
            if (this.isAuthenticated) tag = 'div';
            return tag;
        },
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated'
        })
    }
};
</script>

<style lang="sass" scoped>
.user-form
  // @apply mx-auto
  // width: 100%
  // @screen sm
  //   max-width: theme('screens.sm')
  // @screen md
  //   max-width: theme('screens.md')
  // @screen lg
  //   max-width: theme('screens.lg')
  // @screen xl
  //   max-width: theme('screens.xl')
  @screen md
    padding-bottom: 4rem

  .user-container
    padding: 1rem
    @screen lg
      padding: 1rem 3rem

  .form-grid
    display: grid
    grid-gap: 1rem
    @screen md
      grid-template-rows: auto
      grid-template-columns: max-content auto
    .sidebar
      li
        margin-bottom: 3px
        a
          width: 100%
          padding: 4px 6px 6px
          border: 1px solid var(--color-primary)
          display: inline-block
          line-height: 1
          text-align: left
          font-weight: bold
          transition: background .15s ease, color .15s ease
          &:hover
            @apply outline-black-sm
          &.active
            background: var(--color-primary)
            --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
            color: hsl(0, 0%, var(--switch))
</style>
